export function roundUp (n) {
  let digits,
      nearest;

  digits = Math.log10 (n);
  digits = Math.floor (digits);

  nearest = Math.pow (10, digits);

  return Math.ceil (n / nearest) * nearest;
}

export function round (n, precision) {
  let x = Math.pow (10, precision || 2);

  return Math.round (n * x) / x;
}